import React from 'react'
import { useTranslation } from 'react-i18next'
import { SectionShell } from '../shared/SectionShell'
import { SectionHeading } from '../shared/SectionHeading'
import principles from '../../data/principles.js'

/* "H" disc SVG decoration */
function HDisc({ index }) {
    return (
        <div className="principles-disc" aria-hidden="true">
            <svg viewBox="0 0 120 120" fill="none" width="120" height="120">
                <circle cx="60" cy="60" r="58" stroke="currentColor" strokeWidth="0.8" strokeOpacity="0.18" />
                <circle cx="60" cy="60" r="44" stroke="currentColor" strokeWidth="0.5" strokeOpacity="0.10" />
                <text
                    x="50%"
                    y="50%"
                    dominantBaseline="middle"
                    textAnchor="middle"
                    fontFamily="var(--font-sans)"
                    fontStyle="normal"
                    fontSize="56"
                    fontWeight="400"
                    fill="currentColor"
                    fillOpacity="0.12"
                >
                    H
                </text>
                <text
                    x="50%"
                    y="84%"
                    dominantBaseline="middle"
                    textAnchor="middle"
                    fontFamily="var(--font-mono)"
                    fontSize="10"
                    letterSpacing="0.22em"
                    fill="currentColor"
                    fillOpacity="0.35"
                >
                    {String(index + 1).padStart(2, '0')}
                </text>
            </svg>
        </div>
    )
}

export default function PrinciplesSection() {
    const { t } = useTranslation()

    return (
        <SectionShell id="principles" className="principles-section">
            <SectionHeading label={t('principles.label')} />
            <div className="principles-grid">
                {principles.map((item, i) => (
                    <div key={item.id} className="principles-card">
                        <HDisc index={i} />
                        <p className="principles-text">{t(item.tKey)}</p>
                    </div>
                ))}
            </div>
        </SectionShell>
    )
}
